<template>
	<div class="Map"></div>
</template>

<script>
import gmapsInit from '@/utils/googleMap'

export default {
	name: 'Map',
	async mounted() {
		try {
			const google = await gmapsInit();
			const geocoder = new google.maps.Geocoder();
			const map = new google.maps.Map(this.$el);

			geocoder.geocode({ address: 'Srdana Aleksica 14, Sarajevo' }, (results, status) => {
				if (status !== 'OK' || !results[0]) {
					throw new Error(status);
				}

				map.setCenter(results[0].geometry.location);
				map.fitBounds(results[0].geometry.viewport);
			});

			const markers = this.locations.map(x => new google.maps.Marker({ ...x, map }));
			
		} catch (error) {
			console.error(error);
		}
	},
	data() {
		return {
			locations: [
				{
					position: {
						lat: 43.849777,
						lng: 18.360529
					}
				}
			]
		}
	}
}
</script>

<style lang="scss" scoped>

.Map {
	width: 100%;
  	height: 100%;
}

</style>
